/**
 * Support Module Barrel Export
 *
 * Central export point for all module-specific support registries.
 * Each module file contains support content (hints, explanations, visuals)
 * for families within that module.
 *
 * Usage:
 *   import { STU_SUPPORT, TOPO_SUPPORT } from './modules'
 */

export { STU_SUPPORT, STU_SUPPORT_STATS } from './stu.support'
export { TOPO_SUPPORT, TOPO_SUPPORT_STATS } from './topo.support'
export { REK_SUPPORT, REK_SUPPORT_STATS } from './rek.support'
export { SPR_SUPPORT, SPR_SUPPORT_STATS } from './spr.support'
export { SWW_SUPPORT, SWW_SUPPORT_STATS } from './sww.support'
export { TAA_SUPPORT, TAA_SUPPORT_STATS } from './taa.support'
export { MET_SUPPORT, MET_SUPPORT_STATS } from './met.support'
export { TIJD_SUPPORT, TIJD_SUPPORT_STATS } from './tijd.support'
export { GELD_SUPPORT, GELD_SUPPORT_STATS } from './geld.support'
export { GET_SUPPORT, GET_SUPPORT_STATS } from './get.support'
